export default {
  resources: {
    dataAnalytics: {
      title: 'Data analytics',
      subtitle: 'See detailed data about your users and their activites over time. Export a report as a CSV or Google sheet.',
      cta: 'View Dashboard',
      key: 'dataAnalytics'
    },
    insightVideoProduction: {
      title: 'Insight video production',
      subtitle: 'Have a recording? Send it to our video production team to produce an insight video to be hosted in your video channel.',
      cta: 'Submit an order',
      key: 'insightVideoProduction',
      url: 'https://kintell.typeform.com/video-order'
    },
    socialMediaAsset: {
      title: 'Social media asset',
      subtitle: 'Have an insight video or an amazing 5-star review? Order an asset to engage your network via newsletters or social media posts!',
      cta: 'Submit an order',
      key: 'socialMediaAsset',
      url: 'https://kintell.typeform.com/social-media',
    },
    updateContentBoards: {
      title: 'Update content boards',
      subtitle: 'Add or remove the content boards for best engagement with your community.',
      cta: 'Submit an order',
      key: 'updateContentBoards',
      url: 'https://kintell.typeform.com/content-board'
    },
    oneToOneCustomerSupport: {
      title: '1-to-1 customer support',
      subtitle: 'Book us for an in-depth 1-to-1 video call to answer all your product questions. You can invite your colleagues too!',
      cta: 'Book a video call',
      key: 'oneToOneCustomerSupport'
    },
    inviteNewMembers: {
      title: 'Invite new members',
      subtitle: 'Send this link to your network so they can join your group. Kintell will notify you when they do!',
      cta: 'Copy link',
      key: 'inviteNewMembers'
    },
    adminSharedFolder: {
      title: 'Admin shared folder',
      subtitle: 'A central hub for all your project documents for easy collaboration with Kintell.',
      cta: 'Go to folder',
      key: 'adminSharedFolder'
    },
    shareVideoChannel: {
      title: 'Share video channel',
      subtitle: 'Share this link with anyone so they can watch your video channel!',
      cta: 'Copy link',
      key: 'videoChannelUrl'
    }
  },

  applyForm: {
    adviseHelpOthers: {
      title: 'Advise and help others',
      subtitle: 'Change lives with your expertise! Others can book you for 1-to-1 video chats. You have full control over your offer and availability.'
    },
    learnFromOthers: {
      title: 'Learn from others',
      subtitle: 'Grow your knowledge with 1-to-1 video chats and content from others sharing their expertise.'
    },
    adviseAndLearn: {
      title: 'Both advise and learn',
      subtitle: 'Unlock infinite opportunities by both sharing your expertise and learning from others via 1-to-1 video chats and content.'
    },
    'kintell-akademy': {
      apply: {
        title: 'Unlock your full access',
        subtitle: 'Let\'s make it happen! Just give us your details to unlock full access to ‘Kintell Akademy’.',
      }
    },
    'unsw-career-compass': {
      apply: {
        title: 'Unlock your full access',
        subtitle: `Please provide your details below. 'Career Compass' is a program to support UNSW alumni who have graduated in the past 2 years.  This takes less than 10 sec and the team will get back to you within 48 hours.`,
      }
    }
  }
}
